import api from './api.js'

const HTTP = {...api}
export default HTTP